// This should only be used by getStore() and setStore.
// Don't export in store/fancy-multi-dropdown.js
export const storeManager = {
  store: undefined
};